import Avatar from "@amzn/awsui-chat-components-console/avatar";
import ChatBubble from "@amzn/awsui-chat-components-console/chat-bubble";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';
import { Message } from "../../../context/chatbot/ChatbotContext";

const UserMessage = ({ message }: { message: Message }) => (
    <ChatBubble
        key={message.id}
        type="outgoing"
        ariaLabel={getString('chatbot.ariaLabels.userMessage')}
        avatar={<Avatar ariaLabel={getString('chatbot.ariaLabels.userAvatar')} iconName="user-profile" />}
    >
        {message.text}
    </ChatBubble>
);

export default UserMessage;
